import {
  Button,
  ButtonVariant,
  FormMessage,
  FormMessageVariant,
} from '@aus-platform/design-system';
import { isFunction } from 'lodash';
import { Modal } from 'react-bootstrap';
import { setShowUnsavedFeaturesModal } from 'map-3d/shared/map-3d-slices';
import { useAppDispatch } from 'src/app/hooks';

type UnsavedFeaturesModalProps = {
  show: boolean;
  onExit?: () => void;
  onSaveAndExit?: () => void;
  bodyMessage?: string;
  formMessage?: string;
  showFormMessage?: boolean;
  exitButtonLabel?: string;
  saveButtonLabel?: string;
};

export const UnsavedFeaturesModal: React.FC<UnsavedFeaturesModalProps> = ({
  show,
  onExit,
  onSaveAndExit,
  bodyMessage = 'Are you sure you want to leave this page?',
  formMessage = 'There is unsaved data that will be lost if you proceed.',
  showFormMessage = true,
  exitButtonLabel = 'Exit without Saving',
  saveButtonLabel = 'Save & Exit',
}) => {
  const dispatch = useAppDispatch();

  return (
    <Modal
      show={show}
      onHide={() => {
        dispatch(setShowUnsavedFeaturesModal(false));
      }}
      size="sm"
      backdrop="static"
      className="workspace-unsaved-features-modal workspace-modal"
      centered
    >
      <Modal.Header closeButton> Unsaved Changes </Modal.Header>
      <Modal.Body>
        {bodyMessage}

        {showFormMessage && (
          <FormMessage
            variant={FormMessageVariant.Warning}
            message={formMessage}
          />
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant={ButtonVariant.Secondary}
          onClick={onExit}
          disabled={!isFunction(onExit)}
        >
          {exitButtonLabel}
        </Button>
        <Button onClick={onSaveAndExit} disabled={!isFunction(onSaveAndExit)}>
          {saveButtonLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
